module.exports = __webpack_public_path__ + "static/media/128.42041018.png";